import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  CONVENIENCE_TEST_STAGES_ID,
  ConvenienceTestAnswer,
  UpdateExtraAnswerPayload,
  UpdateExtraAnswersPayload,
} from '@repo/user-types'

interface SelectStage1AnswerPayload {
  questionId: string
  answerId: string
}

const SELECTED_ANSWER_VALUE = '1'

const findAnswer = (
  state: ConvenienceTestAnswer[],
  stage: string,
  questionId: string,
  answerId: string,
) => state.find((a) => a.stage === stage && a.questionId === questionId && a.answerId === answerId)

const initialState: ConvenienceTestAnswer[] = []

export const {
  actions: convenienceTestQuestionnaireAnswersActions,
  reducer: convenienceTestQuestionnaireAnswersReducer,
} = createSlice({
  name: '@users/convenienceTest/questionnaire/answers',
  initialState,
  reducers: {
    reset: () => initialState,
    initialize: (_state, action: PayloadAction<ConvenienceTestAnswer[]>) => action.payload,
    updateStage1Answer: (state, action: PayloadAction<SelectStage1AnswerPayload>) => {
      const { questionId, answerId } = action.payload
      state
        .filter(
          (a) => a.stage === CONVENIENCE_TEST_STAGES_ID.STAGE_1 && a.questionId === questionId,
        )
        .forEach((a) => {
          a.answer = a.answerId === answerId ? SELECTED_ANSWER_VALUE : null
        })
    },
    updateExtraAnswer: (state, action: PayloadAction<UpdateExtraAnswerPayload>) => {
      const { stage, questionId, answerId, value } = action.payload
      const answer = findAnswer(state, stage, questionId, answerId)
      if (answer) {
        answer.extraAnswer = value
      }
    },
    updateContrastAnswers: (state, action: PayloadAction<UpdateExtraAnswersPayload>) => {
      const { stage, questionId, answerId, value } = action.payload

      const answer = findAnswer(state, stage, questionId, answerId)
      if (answer && value === null) {
        answer.extraAnswers = null
        return
      }
      if (!answer || !value) return

      answer.extraAnswers ??= []

      const existingIndex = answer.extraAnswers.findIndex(
        (item) => item.answerId === value.answerId,
      )

      if (existingIndex === -1) {
        answer.extraAnswers.push(value)
        return
      }

      answer.extraAnswers[existingIndex] = value
    },
  },
})
